import script from "./title.vue?vue&type=script&setup=true&lang=js"
export * from "./title.vue?vue&type=script&setup=true&lang=js"

import "./title.vue?vue&type=style&index=0&id=0f3c520f&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3c520f"]])

export default __exports__